import React from 'react';
import PropTypes from 'prop-types';
import { Glyphicon } from 'react-bootstrap';
import ActionMenuWithButton from '../../../atoms/ActionMenu/ActionMenuWithButton';
import ActionMenuItem from '../../../atoms/ActionMenu/ActionMenuItem';
import ActionMenuDiver from '../../../atoms/ActionMenu/ActionMenuDivider';
import childrenOfTypes from '../../../utils/childrenOfTypes';
import withId from '../../../decorators/withId';

import withIdContext from '../../../decorators/withIdContext';

const DataGridActionMenu = ({
  id,
  children,
  disabled,
}) => (
  <ActionMenuWithButton
    bsStyle="default"
    label={
      <Glyphicon glyph="option-vertical" />
    }
    id={id}
    menuRight
    noCaret
    disabled={disabled}
    ariaLabel="Action menu for table row"
  >
    {children}
  </ActionMenuWithButton>
);

DataGridActionMenu.propTypes = {
  children: childrenOfTypes(ActionMenuItem, ActionMenuDiver).isRequired,
  /** Disable button */
  disabled: PropTypes.bool,
  /** Gets called when the user clicks on the button */
  id: PropTypes.string,
};

DataGridActionMenu.defaultProps = {
  disabled: false,
  id: null,
};

export default withIdContext('DataGridActionMenu')(withId('Dropdown')(DataGridActionMenu));
